import { isString } from 'lodash'
import { isMac } from '../isMac'
import { TScrteShortcutKey } from '../types'

export const formatShortcut = (shortcut: TScrteShortcutKey = '') => {
  const formattedShortcutArray = []

  let shortcutText = ''

  if (!shortcut) return ''

  if (isString(shortcut)) {
    shortcutText = shortcut
  } else if (isMac() && shortcut.mac) {
    shortcutText = shortcut.mac
  } else if (shortcut.win) {
    shortcutText = shortcut.win
  }

  shortcutText
    .trim()
    .replace(/\+\+/g, '+')
    .split('+')
    .forEach((shortcut) => {
      let uppercaseShortcut = shortcut.toString().toUpperCase()

      let foundInCommon = true

      // Common symbols
      switch (uppercaseShortcut) {
        case 'UP':
          formattedShortcutArray.push('Up')
          break
        case 'DOWN':
          formattedShortcutArray.push('Down')
          break
        case 'LEFT':
          formattedShortcutArray.push('Left')
          break
        case 'RIGHT':
          formattedShortcutArray.push('Right')
          break
        case 'BACKSPACE':
          formattedShortcutArray.push('Backspace')
          break
        case 'SPACE':
          formattedShortcutArray.push('Space')
          break
        case '':
        case 'ADD':
          formattedShortcutArray.push('Plus')
          break
        default:
          foundInCommon = false
      }

      if (!foundInCommon)
        if (isMac()) {
          switch (uppercaseShortcut) {
            case 'RETURN':
              formattedShortcutArray.push('Return')
              break
            case 'CMD':
            case 'MOD':
              formattedShortcutArray.push('Cmd')
              break
            case 'CTRL':
              formattedShortcutArray.push('Ctrl')
              break
            case 'SHIFT':
              formattedShortcutArray.push('Shift')
              break
            case 'ALT':
            case 'OPTION':
              formattedShortcutArray.push('Opt')
              break
            case 'DELETE':
              formattedShortcutArray.push('Del')
              break
            case 'ESC':
            case 'ESCAPE':
              formattedShortcutArray.push('Esc')
              break
            case 'TAB':
              formattedShortcutArray.push('Tab')
              break
            case 'PAGE UP':
              formattedShortcutArray.push('Page Up')
              break
            case 'PAGE DOWN':
              formattedShortcutArray.push('Page Down')
              break
            case 'HOME':
              formattedShortcutArray.push('Home')
              break
            case 'END':
              formattedShortcutArray.push('End')
              break
            default:
              formattedShortcutArray.push(uppercaseShortcut)
          }
        } else {
          switch (uppercaseShortcut) {
            case 'ENTER':
              formattedShortcutArray.push('Enter')
              break
            case 'CTRL':
            case 'CMD':
            case 'MOD':
              formattedShortcutArray.push('Ctrl')
              break
            case 'SHIFT':
              formattedShortcutArray.push('Shift')
              break
            case 'ALT':
            case 'OPTION':
              formattedShortcutArray.push('Alt')
              break
            case 'DELETE':
              formattedShortcutArray.push('Del')
              break
            case 'ESC':
            case 'ESCAPE':
              formattedShortcutArray.push('Esc')
              break
            case 'TAB':
              formattedShortcutArray.push('Tab')
              break
            case 'PAGE UP':
              formattedShortcutArray.push('Page Up')
              break
            case 'PAGE DOWN':
              formattedShortcutArray.push('Page Down')
              break
            case 'HOME':
              formattedShortcutArray.push('Home')
              break
            case 'END':
              formattedShortcutArray.push('End')
              break
            default:
              if (uppercaseShortcut.length > 1) {
                formattedShortcutArray.push(uppercaseShortcut.toLowerCase())
              } else {
                formattedShortcutArray.push(uppercaseShortcut)
              }
          }
        }
    })

  return formattedShortcutArray.join(' + ')
}